var _style, _defs, _defs2, _path, _defs3, _defs4, _path2, _defs5, _defs6, _path3, _defs7, _path4, _path5, _path6, _path7, _path8, _polygon, _polygon2, _path9, _polygon3, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMowaamahLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 282 105",
    style: {
      enableBackground: "new 0 0 282 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000024687921078668852530000006830369968030876343_);fill:#008182;}\n\t.st1{clip-path:url(#SVGID_00000024687921078668852530000006830369968030876343_);fill:#FF8A00;}\n\t.st2{clip-path:url(#SVGID_00000024687921078668852530000006830369968030876343_);fill:#00B06F;}\n\t.st3{clip-path:url(#SVGID_00000024687921078668852530000006830369968030876343_);fill:#FFB000;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000181789448038115541580000005447492774410556072_);fill:url(#SVGID_00000154405974557568872520000016782368770348125588_);}\n\t.st5{fill:#FF8A00;}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000127731732637265611690000018345084630691304631_);fill:url(#SVGID_00000149363379712599897890000017146071860358564247_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000169543823180702913420000000300219936593929639_);fill:url(#SVGID_00000021101935394211323930000013290142796151946642_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000005945018512147963470000012645275592456351156_);fill:url(#SVGID_00000146484731098658355780000011417145302880325027_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000003067504929761252370000013990196593211850166_);fill:url(#SVGID_00000062153644765511949180000005371706481815609228_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000042710231525836208110000007070820182115558552_);fill:url(#SVGID_00000128443475771507616060000014375054123271851150_);}\n\t.st11{fill:#008182;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M187.2,94.1h13.9c-2.6-2.4-5.1-5-7.4-7.7c-2.3-2.6-4.5-5.4-6.5-8.3V94.1z M268.8,39.9 c-1.4,1.1-2.8,2.2-4.1,3.3c-1.4,1.1-2.8,2.2-4.1,3.4c-1.4,1.1-2.7,2.3-4,3.5c-5.3,4.7-10.5,9.5-15.7,14.3 c-5.1,4.9-10.2,9.8-15.2,14.8c-2.6,2.5-5,5-7.5,7.5l-7.5,7.5h38.2c13.4,0,24.3-10.6,24.3-23.7v0V36.8 C271.6,37.8,270.2,38.9,268.8,39.9 M211.5,10.6c-13.4,0-24.3,10.6-24.3,23.7v20.8c3.1,2.7,6,5.5,9.1,8.2l8.8,7.9 c2.4-2.1,4.9-4.1,7.5-6c2.7-2,5.4-4,8.1-6c5.5-3.9,11.1-7.6,16.8-11.2c5.7-3.6,11.5-7,17.4-10.3c5.8-3.3,11.9-6.4,17.9-9.3 l0.2-0.1V10.6H211.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163785525419541414140000000769609967141197186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000163785525419541414140000000769609967141197186_)",
      fill: "#008182"
    },
    d: "M120.2,59.5 c1.5-0.7,3-1.4,4.5-2.1c-1.8-15.2-2.2-30.6-1.2-45.8c-30.2-1.5-61.1,1.9-93.4,11L120.2,59.5z M290.2,68.3l-85.7,25.8l174.4,71.6 C355.9,123.9,326.2,92.5,290.2,68.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000163785525419541414140000000769609967141197186_)",
      fill: "#FF8A00"
    },
    d: "M140.2,97.6 C136.4,29.7,150.9-31.7,194-89.9l10.4,184.1l10.4,184.1C165.4,224.9,144,165.4,140.2,97.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000163785525419541414140000000769609967141197186_)",
      fill: "#00B06F"
    },
    d: "M4.4,154.3l107.2-32.2 c5.7-11.3,11.9-22.3,18.7-33c-0.9-3.9-1.8-7.8-2.5-11.7c-1.3-6.7-2.3-13.3-3-19.8C77.8,79.7,37.7,110.7,4.4,154.3 M261.3,10.7 L194.1,98l230.2-69.2C369.1,10.2,315.3,5.1,261.3,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000163785525419541414140000000769609967141197186_)",
      fill: "#FFB000"
    },
    d: "M199.4,5.2l5,88.9 L330-69.1C278.4-53.8,235.9-28.6,199.4,5.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000120553405348597029180000015216928060662610355_",
    points: "187.2,55.1 187.2,55.1 187.1,55  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046314280237562982060000005560522102351055759_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120553405348597029180000015216928060662610355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025422434468758647010000013038977011926088635_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.0773,
    y1: 912.7603,
    x2: -32.7595,
    y2: 912.7603,
    gradientTransform: "matrix(26.1804 0 0 -26.1804 1130.6395 23951.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.1,
    y: 55,
    style: {
      clipPath: "url(#SVGID_00000046314280237562982060000005560522102351055759_)",
      fill: "url(#SVGID_00000025422434468758647010000013038977011926088635_)"
    },
    width: 0.1,
    height: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.7,72.3l0.4,0.4l0.4-0.3c5.2-4.2,10.6-8.2,16.1-12c5.5-3.8,11.1-7.6,16.7-11.2c2.8-1.8,5.7-3.6,8.5-5.3 c2.8-1.8,5.7-3.5,8.6-5.3c2.9-1.7,5.8-3.4,8.7-5.1l8.7-5v0c-6,2.9-12.1,6-17.9,9.3c-5.9,3.2-11.7,6.7-17.4,10.3 c-5.7,3.6-11.3,7.3-16.8,11.2c-2.7,2-5.5,3.9-8.1,6c-2.5,1.9-5,3.9-7.5,6l-8.7-7.9c-3.1-2.7-6-5.5-9.1-8.2v0 c2.9,2.9,5.7,5.8,8.6,8.7L204.7,72.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000028290549317315590360000011022064526053750197_",
    d: "M254.9,37.7c-5.9,3.2-11.7,6.7-17.4,10.3 c-5.7,3.6-11.3,7.3-16.8,11.2c-2.8,2-5.5,3.9-8.1,6c-2.6,1.9-5,3.9-7.5,6l-8.8-7.9c-3.1-2.7-6-5.5-9.1-8.2v0 c2.9,2.9,5.7,5.8,8.6,8.7l8.9,8.6l0.4,0.4l0.4-0.3c5.2-4.2,10.6-8.2,16.1-12s11.1-7.6,16.7-11.2c2.8-1.8,5.6-3.6,8.5-5.3 c2.8-1.8,5.7-3.5,8.6-5.3c2.9-1.7,5.8-3.4,8.7-5.1l8.8-5v0C266.8,31.3,260.6,34.4,254.9,37.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181804320506850578150000015798402126113271703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028290549317315590360000011022064526053750197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161589165285703569290000007751895793841244300_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.0773,
    y1: 912.8801,
    x2: -32.7595,
    y2: 912.8801,
    gradientTransform: "matrix(26.1804 0 0 -26.1804 1130.6395 23950.1172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.2,
    y: 28.4,
    style: {
      clipPath: "url(#SVGID_00000181804320506850578150000015798402126113271703_)",
      fill: "url(#SVGID_00000161589165285703569290000007751895793841244300_)"
    },
    width: 85.6,
    height: 44.3
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099664331242166535370000015915218731581503133_",
    points: "187.1,78.1 187.2,78.1 187.2,78.1 187.1,78  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098926171107477439250000011190166055133176197_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099664331242166535370000015915218731581503133_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118382676771753502050000009153867625415303573_",
    gradientUnits: "userSpaceOnUse",
    x1: -215.685,
    y1: 985.551,
    x2: -212.3672,
    y2: 985.551,
    gradientTransform: "matrix(4.4777 0 0 -4.4777 1152.5322 4491.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.1,
    y: 78,
    style: {
      clipPath: "url(#SVGID_00000098926171107477439250000011190166055133176197_)",
      fill: "url(#SVGID_00000118382676771753502050000009153867625415303573_)"
    },
    width: 0,
    height: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.2,78.1L187.2,78.1c2,2.9,4.2,5.7,6.5,8.3c2.3,2.7,4.8,5.3,7.4,7.7c-2-2.9-4.2-5.7-6.6-8.4 C192.2,83,189.8,80.5,187.2,78.1"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034808514248571980230000017488884493160921018_",
    d: "M187.2,78.1c2,2.9,4.2,5.6,6.5,8.3 c2.3,2.7,4.8,5.3,7.4,7.7c-2-2.9-4.2-5.7-6.6-8.4C192.3,83,189.8,80.5,187.2,78.1L187.2,78.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169559348480640051740000008076720391645556885_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034808514248571980230000017488884493160921018_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035490994095367985540000002678240470654974871_",
    gradientUnits: "userSpaceOnUse",
    x1: -215.685,
    y1: 984.3009,
    x2: -212.3672,
    y2: 984.3009,
    gradientTransform: "matrix(4.4777 0 0 -4.4777 1152.5322 4493.5435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.2,
    y: 78.1,
    style: {
      clipPath: "url(#SVGID_00000169559348480640051740000008076720391645556885_)",
      fill: "url(#SVGID_00000035490994095367985540000002678240470654974871_)"
    },
    width: 13.9,
    height: 16
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023965075336678444680000014639473100777712051_",
    d: "M210.5,94.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047037060984282642400000005295996419453006762_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023965075336678444680000014639473100777712051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028295309228979623530000006937342771987289784_",
    gradientUnits: "userSpaceOnUse",
    x1: -16898.9375,
    y1: 7725.1113,
    x2: -16898.9375,
    y2: 7725.1113,
    gradientTransform: "matrix(5.643000e-02 0 0 -5.643000e-02 1164.1136 530.0457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047037060984282642400000005295996419453006762_)",
      fill: "url(#SVGID_00000028295309228979623530000006937342771987289784_)"
    },
    d: " M210.5,94.1L210.5,94.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.5,39.5c-1.5,1-2.9,2-4.4,3c-1.5,1-2.9,2.1-4.3,3.2c-1.4,1.1-2.8,2.2-4.2,3.3c-5.6,4.5-10.8,9.3-16,14.1 c-5.2,4.9-10.2,9.9-15,15.1c-2.4,2.6-4.8,5.2-7.2,7.8c-2.3,2.7-4.7,5.3-6.9,8l7.5-7.5c2.5-2.5,5-5,7.5-7.5 c5.1-5,10.1-9.9,15.2-14.8c5.2-4.8,10.3-9.7,15.7-14.3c1.3-1.2,2.7-2.3,4-3.5c1.4-1.1,2.7-2.3,4.1-3.4c1.4-1.1,2.7-2.3,4.2-3.3 c1.4-1,2.8-2.1,4.2-3.1C271.5,37.7,270,38.6,268.5,39.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065791807182636760370000010358730517360934803_",
    d: "M268.5,39.5c-1.5,1-2.9,2-4.4,3c-1.5,1-2.9,2.1-4.3,3.2 c-1.4,1.1-2.8,2.2-4.2,3.3c-5.5,4.5-10.8,9.3-16,14.1c-5.2,4.9-10.2,9.9-15,15.1c-2.4,2.6-4.8,5.2-7.2,7.8c-2.4,2.7-4.7,5.3-7,8 l7.5-7.5c2.5-2.5,5-5,7.5-7.5c5-5,10.1-9.9,15.3-14.8c5.1-4.8,10.3-9.7,15.7-14.3c1.3-1.2,2.7-2.3,4-3.5c1.4-1.1,2.7-2.3,4.1-3.4 c1.4-1.1,2.8-2.3,4.2-3.3c1.4-1,2.8-2.1,4.2-3.1C271.5,37.7,270,38.6,268.5,39.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173849335799235876880000005278152155402977412_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065791807182636760370000010358730517360934803_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148656333359989730230000014267182881719931043_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.7981,
    y1: 918.1587,
    x2: -45.4803,
    y2: 918.1587,
    gradientTransform: "matrix(19.1576 0 0 -19.1576 1144.8624 17655.1504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EFEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B8BA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 36.7,
    style: {
      clipPath: "url(#SVGID_00000173849335799235876880000005278152155402977412_)",
      fill: "url(#SVGID_00000148656333359989730230000014267182881719931043_)"
    },
    width: 62.5,
    height: 57.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M80.1,48.8L80.1,48.8c0.1-0.3,0.2-0.5,0.4-0.8c0.3-0.5,0.6-1,1.1-1.4c0.7-0.6,1.6-1,2.5-1.2 c2.7-0.3,4.1-0.2,6.8,1.1l0.9-2.5c-1.5-0.9-2-1.3-3.1-1.7c-1.4-0.6-2.1-0.9-4.2-1.1c-1.5,0-2.9,0.3-4.3,0.9c-2,0.8-3.9,2.3-5.4,4.6 c-1,2.2-1.5,4.5-1.5,6.9h-4.7v5.3h23.8v-5.4H79.3C79.3,51.6,79.6,50,80.1,48.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.7,32.9h3.6c0.3,0,0.5-0.1,0.8-0.1c0.7-0.2,1.2-0.8,1.3-1.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1V31 c0-0.1,0-0.1,0-0.2v-0.2v-3.5V27v-0.3v-0.5h-4.7c-0.7,0-1.3,0.3-1.7,0.8c-0.2,0.3-0.3,0.6-0.4,0.9l0,0.2c0,0.1,0,0.2,0,0.3V33 L14.7,32.9L14.7,32.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M23.5,32.9h3.6c0.3,0,0.5-0.1,0.8-0.1c0.7-0.2,1.1-0.8,1.3-1.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1V31 c0-0.1,0-0.1,0-0.2v-0.2v-3.5V27v-0.3v-0.5h-4.7c-0.7,0-1.3,0.3-1.7,0.8c-0.2,0.3-0.3,0.6-0.4,0.9l0,0.2c0,0.1,0,0.2,0,0.3V33 L23.5,32.9L23.5,32.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M47.7,37.1c-3.1,0.1-5.5,1.3-7.1,3.5c-0.8,1.1-1.4,2.5-1.6,3.9l0,0.2v0c0,0.2-0.1,0.4-0.1,0.7v0.1 c0,0.4-0.1,0.8-0.1,1.2v6.9h-9.6V37.1H17.9c-3.1,0.1-5.5,1.3-7.1,3.5C10,41.7,9.4,43,9.2,44.4l0,0.2v0c0,0.2-0.1,0.4-0.1,0.7v0.1 C9,45.8,9,46.2,9,46.6v12.2h44.2c1.1,0,2.1-0.2,3.1-0.6c2.8-1,4.8-3.2,5.5-6.2l0.1-0.3v-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0.1-0.3 c0-0.1,0-0.2,0-0.3v-0.1c0-0.2,0-0.5,0.1-0.7v-0.1c0-0.2,0-0.3,0-0.5v-9.1v-3.1H47.7z M23.8,53.4h-9.2v-6.8c0-0.2,0-0.4,0-0.7 c0-0.2,0-0.3,0.1-0.5c0.1-0.6,0.3-1.1,0.6-1.6c0.6-0.7,1.5-1.1,2.8-1.2h5.7V53.4z M56.6,42.5v6.8v0.3v0.1c0,0.1,0,0.3,0,0.4v0.1 v0.1c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.2l-0.1,0.3V51c-0.3,1.1-0.9,1.8-1.9,2.1c-0.5,0.1-0.9,0.2-1.4,0.3h-8.7v-6.8c0-0.2,0-0.4,0-0.7 c0-0.2,0-0.3,0.1-0.5c0.1-0.6,0.3-1.1,0.6-1.6c0.6-0.7,1.5-1.1,2.8-1.2L56.6,42.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M149.4,37.1h-0.1c-3.1,0.1-5.5,1.3-7.1,3.5c-0.8,1.2-1.4,2.5-1.6,3.9l0,0.2v0c0,0.2-0.1,0.4-0.1,0.7v0.1 c0,0.4-0.1,0.8-0.1,1.2v6.9h-9.2V37.1h-11.4c-3.1,0.1-5.5,1.3-7.1,3.5c-0.8,1.1-1.4,2.5-1.6,3.9l0,0.2v0c0,0.2-0.1,0.4-0.1,0.7v0.1 c0,0.4-0.1,0.8-0.1,1.2v12.2h15c-0.3,5.2-3.1,8.9-8.3,10.8l1.3,2.3c7.5-1.9,11.3-6.3,12.3-13.1l7.8,0h15.8c1.1,0,2.1-0.2,3.1-0.6 c2.8-1,4.8-3.2,5.5-6.2l0.1-0.3v-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3l0-0.1c0-0.2,0-0.5,0.1-0.7v-0.1 c0-0.2,0-0.3,0-0.5v-9.1v-3.1H149.4z M125.7,53.4h-9.2v-6.8c0-0.2,0-0.4,0-0.7c0-0.2,0-0.3,0.1-0.5c0.1-0.6,0.3-1.1,0.6-1.6 c0.6-0.8,1.5-1.1,2.8-1.2h5.7L125.7,53.4z M158.1,49.3v0.3v0.1c0,0.1,0,0.3,0,0.4v0.1v0.1l0,0.2c0,0.1,0,0.1,0,0.2l-0.1,0.2V51 c-0.3,1.1-0.9,1.8-1.9,2.1c-0.5,0.1-0.9,0.2-1.4,0.2h-8.7v-6.8c0-0.2,0-0.4,0-0.7c0-0.2,0-0.3,0.1-0.5c0.1-0.6,0.3-1.1,0.6-1.6 c0.6-0.8,1.5-1.1,2.8-1.2h8.7L158.1,49.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "98.7,23.8 98.7,31.7 98.7,58.8 104.4,58.8 104.4,31.7 104.3,23.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "17.6,94.1 12.7,76.7 12.7,94.1 9,94.1 9,73.7 15.3,73.7 19.9,90.9 24.5,73.7 30.8,73.7 30.8,94.1  27.1,94.1 27.1,76.7 22.2,94.1  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.3,93.8c-2,0.8-4.2,0.8-6.2,0c-0.9-0.4-1.8-0.9-2.5-1.6c-0.7-0.7-1.3-1.5-1.7-2.4c-0.4-0.9-0.6-1.9-0.6-3 c0-1,0.2-2,0.6-2.9c0.8-1.8,2.3-3.2,4.2-4c2-0.8,4.2-0.8,6.2,0c1.9,0.7,3.4,2.2,4.2,4c0.4,0.9,0.6,1.9,0.6,2.9c0,1-0.2,2-0.6,3 c-0.4,0.9-1,1.7-1.7,2.4C47,92.9,46.2,93.5,45.3,93.8 M40.4,90.7c1.1,0.4,2.3,0.4,3.4,0c0.5-0.2,0.9-0.5,1.3-0.9 c0.4-0.4,0.6-0.8,0.8-1.3c0.4-1,0.4-2.1,0-3.1c-0.2-0.5-0.5-0.9-0.8-1.3c-0.4-0.4-0.8-0.7-1.3-0.9c-1.1-0.4-2.3-0.4-3.4,0 c-0.5,0.2-0.9,0.5-1.3,0.9c-0.4,0.4-0.6,0.8-0.8,1.3c-0.4,1-0.4,2.1,0,3.1C38.7,89.5,39.5,90.3,40.4,90.7L40.4,90.7z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "64.9,94.1 62.5,83.1 60,94.1 55.1,94.1 51.2,79.9 55.1,79.9 57.8,90.8 60.3,79.9 64.6,79.9  67.1,90.8 69.8,79.9 73.8,79.9 69.9,94.1  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.1,94.4c-0.9,0-1.8-0.1-2.6-0.2c-0.8-0.1-1.5-0.4-2.2-0.8c-0.6-0.4-1.1-0.9-1.5-1.4 c-0.4-0.7-0.6-1.4-0.6-2.2c0-1.4,0.7-2.8,1.9-3.6c0.7-0.4,1.4-0.7,2.1-0.9c0.9-0.2,1.8-0.3,2.7-0.3c0.4,0,0.8,0,1.3,0 c0.5,0,1,0.1,1.5,0.2v-0.2c0-0.8-0.3-1.4-0.9-1.6c-0.8-0.3-1.6-0.5-2.4-0.4c-0.4,0-0.8,0-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3 c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.1-0.8,0.3-1.2,0.5l0.5-3.6c0.7-0.3,1.5-0.6,2.2-0.8c0.9-0.2,1.9-0.3,2.9-0.3 c0.9,0,1.7,0.1,2.6,0.3c0.7,0.2,1.4,0.5,2.1,1c0.6,0.5,1.1,1.1,1.4,1.7c0.3,0.8,0.5,1.7,0.5,2.6v8.3c-1,0.4-2,0.6-3.1,0.8 C84.3,94.3,83.2,94.4,82.1,94.4 M84.8,88c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4-0.1-0.8-0.1-1.3-0.1c-0.4,0-0.9,0-1.3,0.1 c-0.4,0-0.7,0.2-1.1,0.3c-0.3,0.1-0.5,0.3-0.7,0.6c-0.5,0.7-0.3,1.6,0.4,2.1c0.1,0.1,0.2,0.1,0.3,0.1c0.7,0.3,1.5,0.4,2.3,0.4 c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.9-0.2,1.3-0.3L84.8,88z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.4,94.4c-0.9,0-1.8-0.1-2.6-0.2c-0.8-0.1-1.5-0.4-2.2-0.8c-0.6-0.4-1.1-0.9-1.5-1.4 c-0.4-0.7-0.6-1.4-0.6-2.2c0-1.4,0.7-2.8,1.9-3.6c0.7-0.4,1.4-0.7,2.1-0.9c0.9-0.2,1.8-0.3,2.7-0.3c0.4,0,0.8,0,1.3,0 c0.5,0,1,0.1,1.5,0.2v-0.2c0-0.8-0.3-1.4-0.9-1.6c-0.8-0.3-1.6-0.5-2.4-0.4c-0.4,0-0.8,0-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3 c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.1-0.8,0.3-1.2,0.5l0.5-3.6c0.7-0.3,1.5-0.6,2.3-0.8c0.9-0.2,1.9-0.3,2.9-0.3 c0.9,0,1.7,0.1,2.6,0.3c0.7,0.2,1.4,0.5,2.1,1c0.6,0.5,1.1,1.1,1.4,1.7c0.3,0.8,0.5,1.7,0.5,2.6v8.3c-1,0.4-2,0.6-3.1,0.8 C100.6,94.3,99.5,94.4,98.4,94.4 M101.2,88c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4-0.1-0.8-0.1-1.3-0.1c-0.4,0-0.9,0-1.3,0.1 c-0.4,0-0.7,0.2-1.1,0.3c-0.3,0.1-0.5,0.3-0.7,0.6c-0.5,0.7-0.3,1.6,0.4,2.1c0.1,0.1,0.2,0.1,0.3,0.1c0.7,0.3,1.5,0.4,2.3,0.4 c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.9-0.2,1.3-0.3L101.2,88z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.5,86.2c0-1.3-0.2-2.2-0.7-2.6c-0.5-0.5-1.2-0.7-2.2-0.7c-0.9,0-1.9,0.2-2.7,0.6c0.1,0.2,0.1,0.3,0.2,0.5 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3,0.1,0.5,0.1,0.8c0,0.3,0,0.5,0,0.7v8h-3.6v-7.9c0-0.5,0-1.1-0.2-1.6c-0.1-0.4-0.3-0.7-0.5-1 c-0.3-0.3-0.6-0.4-0.9-0.5c-0.4-0.1-0.9-0.2-1.3-0.2c-0.4,0-0.7,0-1.1,0.1l-1.3,0.2v10.9h-3.6V80.2c1.2-0.2,2.3-0.4,3.3-0.5 c0.9-0.1,1.8-0.2,2.7-0.2c0.8,0,1.5,0.1,2.3,0.2c0.7,0.1,1.3,0.4,1.8,0.8c0.8-0.3,1.6-0.6,2.5-0.8c0.8-0.2,1.6-0.3,2.4-0.3 c0.8,0,1.7,0.1,2.5,0.3c0.7,0.1,1.4,0.5,2,0.9c0.6,0.5,1.1,1.1,1.3,1.8c0.4,0.9,0.5,1.9,0.5,2.9v8.9h-3.6V86.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M140.1,94.4c-0.9,0-1.8-0.1-2.6-0.2c-0.8-0.1-1.5-0.4-2.2-0.8c-0.6-0.4-1.1-0.9-1.5-1.4 c-0.4-0.7-0.6-1.4-0.6-2.2c0-1.4,0.7-2.8,1.9-3.6c0.7-0.4,1.4-0.7,2.1-0.9c0.9-0.2,1.8-0.3,2.7-0.3c0.4,0,0.8,0,1.3,0 c0.5,0,1,0.1,1.5,0.2v-0.2c0-0.8-0.3-1.4-0.9-1.6c-0.8-0.3-1.6-0.5-2.4-0.4c-0.4,0-0.8,0-1.2,0.1c-0.5,0.1-0.9,0.2-1.4,0.3 c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.1-0.8,0.3-1.2,0.5l0.5-3.6c0.7-0.3,1.5-0.6,2.3-0.8c0.9-0.2,1.9-0.3,2.9-0.3 c0.9,0,1.7,0.1,2.6,0.3c0.7,0.2,1.4,0.5,2.1,1c0.6,0.5,1.1,1.1,1.4,1.7c0.3,0.8,0.5,1.7,0.5,2.6v8.3c-1,0.4-2,0.6-3.1,0.8 C142.3,94.3,141.2,94.4,140.1,94.4 M142.8,88c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4-0.1-0.8-0.1-1.3-0.1c-0.4,0-0.9,0-1.3,0.1 c-0.4,0-0.7,0.2-1.1,0.3c-0.3,0.1-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.6-0.3,0.9c0,0.6,0.3,1.2,0.9,1.4c0.7,0.3,1.5,0.4,2.3,0.4 c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.9-0.2,1.3-0.3L142.8,88z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M154,79.7c0.6-0.1,1.1-0.2,1.6-0.2c0.4-0.1,0.9-0.1,1.3-0.1c0.9,0,1.8,0.1,2.6,0.3c0.8,0.1,1.5,0.5,2.1,0.9 c0.6,0.5,1.1,1.1,1.4,1.8c0.4,0.9,0.6,1.9,0.5,2.9v8.9H160v-7.9c0-1.3-0.3-2.2-0.8-2.7c-0.6-0.5-1.4-0.7-2.4-0.7 c-0.4,0-0.9,0-1.3,0.1c-0.5,0-1,0.1-1.5,0.2v11h-3.6V73.7h3.6V79.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMowaamahLogoColor);
export default __webpack_public_path__ + "static/media/mowaamah-logo-color.88e7a03e2715cc858bbdabfa9be6525a.svg";
export { ForwardRef as ReactComponent };